import { Region } from "../types";

export abstract class ModuleProduct {
    /**
     * Name used by class. Usually product or brand name.
     */
    abstract moduleName: string;

    /**
     * SVG with styled path positioned on a background image. To be displayed to user.
     */
    abstract svgPreview(text: string, region: Region): string;

    /**
     * SVG with styled path positioned on a background image. To be submitted for print.
     */
    abstract svgPrint(text: string, region: Region): string;
}
